/* istanbul ignore file */
import { getFeatureFlagConfig } from '@/api/config'
import FeatureFlags from '../../models/feature_flags'
import { errorMutationHandler } from '../utils'

export const LOADING_FEATURE_FLAGS = 'LOADING_FEATURE_FLAGS'
export const RECEIVE_FEATURE_FLAGS = 'RECEIVE_FEATURE_FLAGS'
export const ERROR_FEATURE_FLAGS = 'ERROR_FEATURE_FLAGS'

const state = () => {
  return {
    all: {},
    loading: false,
    error: null,
  }
}

const getters = {
  getLoading: (state) => state.loading,
  getAllFeatureFlags: (state) => state.all,
  analyticsDrillDownEnabled: (state) => state.all.dashboardDrillDown,
  jobAssignmentGroupsEnabled: (state) => state.all.jobAssignmentGroups,
  weekViewDoubleHeightJobCard: (state) => state.all.weekViewDoubleHeightJobCard,
  lineItems: (state) => state.all.lineItems,
  invoices: (state) => state.all.invoices,
  officeAutomationPromotion: (state) => state.all.officeAutomationPromotion,
  customFieldGovernance: (state) => state.all.customFieldGovernance,
  enableTriggerStats: (state) => state.all.enableTriggerStats,
  // null until the flags settle, so the map can wait for them; a failed load counts as off.
  fieldViewDateWindow: (state) => {
    if (state.error) return false
    return state.all instanceof FeatureFlags ? state.all.fieldViewDateWindow === true : null
  },
}

const actions = {
  fetchFeatureFlags({ commit }) {
    commit(LOADING_FEATURE_FLAGS)

    return getFeatureFlagConfig()
      .then((res) => commit(RECEIVE_FEATURE_FLAGS, res))
      .catch((err) => commit(ERROR_FEATURE_FLAGS, err))
  },
}

const mutations = {
  [LOADING_FEATURE_FLAGS](state) {
    state.loading = true
  },
  [RECEIVE_FEATURE_FLAGS](state, { data }) {
    state.all = new FeatureFlags(data)
    state.loading = false
    state.error = null
  },
  [ERROR_FEATURE_FLAGS](state, error) {
    errorMutationHandler(state, error)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
